/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module HttpModule
 */

import {
    HttpEvent,
    HttpHandler,
    HttpInterceptor,
    HttpRequest,
} from '@angular/common/http';

import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { removeLeadingSlash } from '../utils/interceptors.utils';

/**
 * @description
 *     Interceptor to ensure that requests are made using relative paths instead of absolute paths. This is needed to
 *     allow for flexibility in how the controller is deployed.
 * @author alextsg
 */
@Injectable()
export class UseRelativePathsInterceptor implements HttpInterceptor {
    /** @override */
    public intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const { url } = req;

        const clonedRequest = req.clone({ url: removeLeadingSlash(url) });

        return next.handle(clonedRequest);
    }
}
